import PropTypes from 'prop-types';
import { WHITE } from 'consts/colors';
import { Svg, Rect } from './CustomPlaceholder.style';

const CustomPlaceholder = ({ color, width, height, ...attrs }) => {
  return (
    <>
      <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
        <Rect {...attrs} width={width} height={height} fill={color} />
      </Svg>
    </>
  );
};

CustomPlaceholder.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  attrs: PropTypes.object,
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

CustomPlaceholder.defaultProps = {
  attrs: {},
  color: WHITE,
  width: '100%',
  height: '100%',
};
export default CustomPlaceholder;
